import { render, staticRenderFns } from "./TopBarGroup.vue?vue&type=template&id=806c11c2&scoped=true&"
import script from "./TopBarGroup.vue?vue&type=script&lang=js&"
export * from "./TopBarGroup.vue?vue&type=script&lang=js&"
import style0 from "./TopBarGroup.vue?vue&type=style&index=0&id=806c11c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806c11c2",
  null
  
)

export default component.exports